export default 'M2 22h20V2H2z';